export default __webpack_public_path__ + "static/media/cha2.fa5871e7.png";